import { useState } from "react"
import { Link } from "react-router-dom"
import data from "../data/db.json"

export default function Accessories() {
  // const [text, setText] = useState("")
  const [cards] = useState(data.accessories)

  // const handleFilter = (e) => {
  //   e.preventDefault()
  // }

  return (
    <>
      <section className="accessories">
        <div className="accessories-heading flex flex-col items-center justify-center text-center">
          <article className="px-5">
            <h1 className="text-white">Accessories</h1>
            <p className="text-slate-200 mt-3">
              There's always something you can improve. Find it on this page.
            </p>
          </article>

          {/* <form
            onSubmit={handleFilter}
            className="mt-5 px-5 flex flex-col sm:flex-row"
          >
            <input
              type="text"
              name="search"
              id="search"
              placeholder="Type something to search"
              required
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="py-2 px-4 rounded-full mb-2 sm:mb-0 sm:mr-2"
            />
            <button type="submit" onClick={handleFilter} className="btn-black">
              Filter
            </button>
          </form> */}
        </div>

        <div className="max-width py-10 lg:py-20 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-10">
          {cards.map(({ id, name, desc, features, price, images }) => (
            <Link
              to={`/accessories/${name}`}
              key={id}
              className="bg-slate-100 hover:bg-slate-200 transition-all duration-150 rounded-lg shadow-md"
            >
              <img
                src={images[0]}
                alt={name}
                className="md:h-72 md:object-cover md:w-full rounded-t-lg"
              />

              <article className="p-5">
                <div>
                  <h5 className="capitalize">{name}</h5>
                  <h6>{price}</h6>
                </div>
                <p className="text-sm mt-3">{desc}</p>
              </article>

              <article className="px-5 pb-5">
                <h6>Features</h6>
                {features.map((f, index) => (
                  <li key={index} className="text-slate-700 text-sm">
                    {f}
                  </li>
                ))}
              </article>
            </Link>
          ))}
        </div>
      </section>
    </>
  )
}
